export default "__VITE_ASSET__B8W$$XiN__"